import clsx from "clsx";
import React, { MouseEventHandler } from "react";

import CommonButton, { ButtonVariant } from "..";

type Props = {
  disabled?: boolean;
  validation?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  title: string;
  className?: string;
  buttonClassName?: string;
  variant?: ButtonVariant;
  isFixed?: boolean;
};

export default function BottomButtonGroup({
  disabled,
  validation,
  onClick,
  title,
  className,
  buttonClassName,
  variant = "primary",
  isFixed = true,
}: Props) {
  return (
    <div
      className={clsx([
        { fixed: isFixed },
        "bottom-0 left-0 right-0 h-bottom-button bg-white z-30",
        className,
      ])}
    >
      <CommonButton
        className={clsx([
          "w-full h-bottom-button rounded-none",
          buttonClassName,
        ])}
        validation={validation}
        disabled={disabled}
        onClick={onClick}
        variant={disabled ? "disabled" : variant}
      >
        {title}
      </CommonButton>
    </div>
  );
}
